
import { Routes } from '@angular/router';
import { PelecardTransactionsList } from './pele-card-transactions-list.cmp';

export const PelecardTransactionsRoutes: Routes = [
    { path: 'peleCardTransactions', data: { title: 'פעולות' }, component: PelecardTransactionsList}
];

